import { useMemo } from "react";

const REGIONS = [
  { id: "north",  label: "Noord (Porto/Aveiro/Silver Coast)",   latMin: 40.0, latMax: 42.5 },
  { id: "middle", label: "Midden (Lissabon/Setúbal/Alentejo)",  latMin: 38.0, latMax: 40.0 },
  { id: "south",  label: "Zuid (Alentejo kust/Algarve)",         latMin: 36.5, latMax: 38.0 },
];

function kmBetween(a, b) {
  const R = 6371;
  const dLat = (b.lat - a.lat) * Math.PI / 180;
  const dLon = (b.lon - a.lon) * Math.PI / 180;
  const s = Math.sin(dLat/2)**2 + Math.cos(a.lat * Math.PI/180) * Math.cos(b.lat * Math.PI/180) * Math.sin(dLon/2)**2;
  return Math.round(R * 2 * Math.atan2(Math.sqrt(s), Math.sqrt(1-s)));
}

export function VisitPlanner({ towns, concelhoBySlug, weights, enforceVeto, onClose }) {
  const passing = useMemo(() => {
    return towns
      .map(t => {
        const score = t.scores ? Object.values(t.scores).filter(v => typeof v === "number" && v <= 5).reduce((a,b) => a+b, 0) : 0;
        return { ...t, _score: score };
      })
      .filter(t => t.lat && t.lon)
      .sort((a,b) => b._score - a._score)
      .slice(0, 15);
  }, [towns]);

  const grouped = useMemo(() => {
    return REGIONS.map(r => ({
      ...r,
      towns: passing
        .filter(t => t.lat >= r.latMin && t.lat < r.latMax)
        .sort((a,b) => b.lon - a.lon),
    })).filter(r => r.towns.length > 0);
  }, [passing]);

  return (
    <div style={{
      position: "fixed", inset: 0, zIndex: 800,
      background: "rgba(0,0,0,0.5)",
      display: "flex", alignItems: "center", justifyContent: "center",
    }} onClick={onClose}>
      <div style={{
        background: "#faf8f4", borderRadius: 16, padding: "24px",
        width: "min(600px, 95vw)", maxHeight: "85vh", overflowY: "auto",
      }} onClick={e => e.stopPropagation()}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
          <h2 style={{ margin: 0, fontSize: 18, fontWeight: 700 }}>🗺 Bezoekplanner</h2>
          <button onClick={onClose} style={{ background: "none", border: "none", fontSize: 22, cursor: "pointer" }}>✕</button>
        </div>
        <p style={{ fontSize: 13, color: "#666", marginTop: 0, marginBottom: 20 }}>
          Top-locaties per regio, gesorteerd op score. Rij van noord naar zuid of kies één regio per trip.
        </p>

        {grouped.map(region => (
          <div key={region.id} style={{ marginBottom: 24 }}>
            <div style={{ fontSize: 13, fontWeight: 700, color: "#2d5a8e", marginBottom: 10,
                          borderBottom: "1px solid #e5e0d8", paddingBottom: 6 }}>
              {region.label}
            </div>
            {region.towns.map((t, i) => {
              const next = region.towns[i+1];
              const km   = next ? kmBetween(t, next) : null;
              return (
                <div key={t.name}>
                  <div style={{ display: "flex", alignItems: "center", gap: 10,
                                padding: "8px 0", fontSize: 13 }}>
                    <div style={{ width: 28, height: 28, borderRadius: "50%",
                                  background: "#2d5a8e", color: "white",
                                  display: "flex", alignItems: "center", justifyContent: "center",
                                  fontSize: 11, fontWeight: 700, flexShrink: 0 }}>
                      {i+1}
                    </div>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontWeight: 600 }}>{t.name}</div>
                      <div style={{ fontSize: 11, color: "#888" }}>{t.region} · {t.dist_airport || ""}</div>
                    </div>
                    <div style={{ fontSize: 11, color: "#888" }}>
                      {t.land_price || ""}
                    </div>
                  </div>
                  {km && (
                    <div style={{ marginLeft: 38, fontSize: 11, color: "#aaa", paddingBottom: 4 }}>
                      ↓ {km} km naar {next.name} (~{Math.round(km/75)} uur rijden)
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        ))}

        <div style={{ marginTop: 16, padding: "12px", background: "#f0ece4",
                      borderRadius: 8, fontSize: 12, color: "#666" }}>
          💡 Tip: Rij van noord naar zuid. Plan 2–3 nachten per regio voor een goed gevoel.
        </div>
      </div>
    </div>
  );
}
